
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Monthlycabserviceinthane() {



const cardData =
{
  keyword: 'Monthly Cab Service in Thane',
  heading: 'eTravo: Monthly Cab Service in Thane for Corporates and Employees',
  headingDescription: 'eTravo provides dependable, customized monthly cab rental services across Thane for corporate offices, SMEs, startups, and professional teams. Whether you’re looking for daily executive mobility, shift-based staff transport, or airport transfers, our monthly cab plans are built for consistency, comfort, and flexibility. With a wide fleet of hatchbacks, sedans, and executive cars, each vehicle is driven by trained chauffeurs and tracked via GPS. Enjoy fixed monthly pricing, real-time trip management, and a dedicated support team — making eTravo the trusted mobility partner for businesses operating in Thane’s evolving corporate ecosystem.',

  top: 'Top Corporate Zones in Thane Served by eTravo Monthly Cab Services',
  topPlaces: [
    {
      title: 'Wagle Estate MIDC',
      description: 'Thane’s primary industrial and commercial zone, home to hundreds of manufacturing units, IT companies, and logistics firms. eTravo offers daily staff commute and executive-level cab rentals here through long-term subscription packages with route optimization.'
    },
    {
      title: 'Ghodbunder Road',
      description: 'A rapidly growing area connecting Thane to western suburbs, lined with offices, residential complexes, and corporate towers. Our monthly cab service is ideal for businesses needing smooth travel for mid-level managers and team leads.'
    },
    {
      title: 'Thane West Commercial Belt',
      description: 'This region includes key areas like Panchpakhadi, Teen Hath Naka, and Majiwada. Our cab services here support daily pickups and drops for employees and VIP clients, with special packages for healthcare, retail, and consulting businesses.'
    },
    {
      title: 'Kapurbawdi Junction',
      description: 'A central transport hub close to business complexes and premium hotels. eTravo services corporate clients here with chauffeur-driven cabs and recurring monthly rental plans for CXOs and senior management.'
    },
    {
      title: 'Hiranandani Estate, Patlipada',
      description: 'This premium residential-business hybrid houses startup hubs, coworking offices, and realty firms. Our monthly cabs offer scheduled pickups for staff and on-demand services for visiting clients or consultants.'
    },
    {
      title: 'Thane Railway Station Area',
      description: 'Often used as a node for intercity staff or vendors. eTravo helps businesses manage first-mile/last-mile transport here with monthly cab assignments and easy route switching based on shift rosters.'
    },
    {
      title: 'Tikuji-Ni-Wadi Area',
      description: 'Home to corporate offsites, team outings, and weekend event venues. Our monthly cab plans offer full-day availability and special holiday scheduling for HR and admin teams managing staff outings.'
    },
    {
      title: 'Bhiwandi Logistics Corridor',
      description: 'Many warehouses and transport companies in this belt use our monthly cab services for staff dispatch and operations management. We offer early morning and late-night service windows with live trip tracking.'
    },
    {
      title: 'Eastern Express Highway Access Points',
      description: 'Ideal for companies with intercity staff movement. We provide strategic pickup locations along this corridor with high-frequency cab operations under subscription packages.'
    },
    {
      title: 'Viviana Mall & Jupiter Hospital Zone',
      description: 'A mixed-use district where eTravo provides corporate cabs for hospital staff, consultants, and mall-based service firms needing recurring employee transport under monthly contracts.'
    }
  ],

  services: [
    {
      name: 'Thane Corporate Monthly Cab Hire',
      description: 'Ideal for large companies and startups with fixed office hours or shift rotations. Our monthly cab hire plans include route-mapped pickup/drop schedules, verified drivers, fuel plans, and full GST billing — all under one contract.'
    },
    {
      name: 'Long-Term Employee Cab Rentals Thane',
      description: 'Support your growing workforce with long-term employee transport using eTravo’s AC cabs. We handle fixed-time routes, late-shift coverage, and weekend operations while providing you with trip summaries and support.'
    },
    {
      name: 'Business Monthly Cab Service Thane',
      description: 'Perfect for field professionals, marketing teams, and service providers. Our business cab rentals ensure you get access to clean, GPS-tracked cabs with courteous drivers and flexible day-to-day scheduling.'
    },
    {
      name: 'Affordable Monthly Corporate Cabs Thane',
      description: 'Startups and mid-size companies benefit from our economical monthly plans that balance cost and service. Choose from budget hatchbacks routes, or time-based rental models with no hidden fees.'
    },
    {
      name: 'Reliable Corporate Cab Hire Thane',
      description: 'We guarantee consistency in cab availability, punctuality, and vehicle condition. Backup vehicles, route managers, and trained chauffeurs ensure you never miss a workday, shift, or meeting.'
    },
    {
      name: 'Monthly Staff Commute Thane',
      description: 'Designed for IT, healthcare, and service-sector teams, our staff commute plans ensure timely daily pickup and drop across Thane, with dynamic routing, driver ID logs, and attendance reporting.'
    },
    {
      name: 'Executive Monthly Cab Service Thane',
      description: 'Our luxury cab options for top-tier professionals include leather seating, rear AC controls, and business-class cabin interiors — perfect for directors, consultants, and client-facing personnel.'
    },
    {
      name: 'Monthly Business Cab Rentals Thane',
      description: 'Get uninterrupted cab support for continuous business movement. Our rentals offer weekday and weekend flexibility, real-time booking modification, and multi-zone pickup coordination for hybrid workforces.'
    },
    {
      name: 'Corporate Lease Cab Thane',
      description: 'No fleet? No problem. Lease our vehicles on long-term contracts complete with maintenance, registration, and chauffeur support. Scalable plans ideal for operational teams and factory managers.'
    },
    {
      name: 'Monthly Airport Transfer Thane',
      description: 'Ensure smooth travel to Mumbai Airport from Thane with recurring airport drop services, 24/7 dispatch, real-time flight tracking, and luxury cabs for your staff, clients, or VIP guests.'
    },
    {
      name: 'Monthly Cab for Employee Transport Thane',
      description: 'We handle company-wide employee transport programs with detailed routing, cluster-based pickups, driver replacements, and direct admin access to trip status and monthly analytics.'
    },
    {
      name: 'Monthly VIP Cab Thane',
      description: 'For dignitaries, investors, and key officials, we offer premium cabs with formal chauffeurs, privacy partitions, refreshments, and personalized service for daily or event-based travel.'
    },
    {
      name: 'Corporate Subscription Cab Thane',
      description: 'Subscribe to eTravo’s monthly plans for guaranteed daily availability. Easily scale up during peak seasons or events, with billing transparency and support from our corporate account managers.'
    },
    {
      name: 'Flexible Monthly Cab Plans Thane',
      description: 'Need to change routes mid-month or assign additional vehicles? Our plans are built with flexibility so that your business doesn’t have to compromise on mobility.'
    },
    {
      name: 'Long-Term Cab Service Thane',
      description: 'Year-round support for departments or senior executives. Assign dedicated cabs and chauffeurs to your teams with predictable monthly billing and continuous vehicle health monitoring.'
    }
  ],

  tableData: [
    ['Thane Corporate Monthly Cab Hire', 'Long-Term Employee Cab Rentals Thane'],
    ['Business Monthly Cab Service Thane', 'Affordable Monthly Corporate Cabs Thane'],
    ['Reliable Corporate Cab Hire Thane', 'Monthly Staff Commute Thane'],
    ['Executive Monthly Cab Service Thane', 'Monthly Business Cab Rentals Thane'],
    ['Corporate Lease Cab Thane', 'Monthly Airport Transfer Thane'],
    ['Monthly Cab for Employee Transport Thane', 'Monthly VIP Cab Thane'],
    ['Corporate Subscription Cab Thane', 'Flexible Monthly Cab Plans Thane'],
    ['Long-Term Cab Service Thane', '']
  ],



"whychoose": [
    {
        "WhyChooseheading": "Dependable Monthly Cab Service for Corporates in Thane",
        "WhyChoosedescription": "eTravo offers monthly cab rental solutions for businesses across Thane, including Wagle Estate, Ghodbunder Road, Majiwada, and other commercial zones—ensuring consistent, safe, and cost-effective travel for staff and executives."
    },
    {
        "WhyChooseheading": "Fleet for All Levels of Corporate Mobility",
        "WhyChoosedescription": "Our fleet includes hatchbacks, sedans, and SUVs suited for admin staff, field teams, and management. All vehicles are maintained to deliver comfort, efficiency, and reliability for daily operations."
    },
    {
        "WhyChooseheading": "Fixed Driver and Vehicle Allocation for Each Client",
        "WhyChoosedescription": "Clients receive a dedicated vehicle and professionally trained chauffeur for the month. Drivers are punctual, background-verified, and familiar with Thane’s corporate and residential areas."
    },
    {
        "WhyChooseheading": "Flexible Contracts, No Long-Term Lock-In",
        "WhyChoosedescription": "Our monthly rental model allows businesses to upgrade, scale, or cancel based on their transport demand—no lengthy contracts or rigid terms."
    },
    {
        "WhyChooseheading": "Fuel and Non-Fuel Packages for Budget Control",
        "WhyChoosedescription": "We offer both fuel-inclusive and fuel-exclusive plans. Choose the option that matches your internal reimbursement policy and control your monthly expenses effectively."
    },
    {
        "WhyChooseheading": "Hygienic, Sanitized, and GPS-Enabled Vehicles",
        "WhyChoosedescription": "All cabs are sanitized before use and equipped with GPS tracking, first-aid kits, fire extinguishers, and seat belts, ensuring maximum safety and hygiene standards."
    },
    {
        "WhyChooseheading": "Centralized Monitoring and Admin Dashboard",
        "WhyChoosedescription": "Track routes, ride usage, driver performance, and ETAs from our admin dashboard. Ideal for companies with multiple pickup points or shift schedules in Thane."
    },
    {
        "WhyChooseheading": "GST-Compliant Monthly Invoicing and Reporting",
        "WhyChoosedescription": "Get detailed invoices with trip logs, digital receipts, and GST-compliant billing—streamlining accounting, audits, and monthly expense reports for your admin or finance teams."
    }
]
}

const faqData = [
    [
        {
            question: 'Which areas in Thane are covered under the monthly cab service?',
            answer: 'We serve all major locations including Wagle Estate, Thane West, Ghodbunder Road, Pokhran, Majiwada, and Eastern Express Highway areas.'
        },
        {
            question: 'Can we book monthly cabs for different departments?',
            answer: 'Yes, we can assign different vehicles to separate teams or departments with customized scheduling, billing, and reporting.'
        },
        {
            question: 'Do you provide dedicated drivers with fixed timing?',
            answer: 'Yes, our monthly rental service includes professional drivers assigned exclusively to your company for scheduled pickup and drop times.'
        },
        {
            question: 'Is GPS tracking available in real-time?',
            answer: 'Absolutely. All our cabs are GPS-enabled and monitored live, allowing you to track location, get ETAs, and ensure route accuracy.'
        },
        {
            question: 'Can we switch vehicles mid-month if required?',
            answer: 'Yes, depending on availability, we allow mid-month upgrades, downgrades, or replacements based on your evolving needs.'
        },
        {
            question: 'Will we get monthly GST-compliant invoices?',
            answer: 'Yes, we provide digital GST invoices and itemized ride logs every month to make expense tracking and compliance effortless.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Shrikant Patil',
        designation: 'Admin Manager, Quantix Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s monthly cab services in Thane are professional and highly reliable. Their drivers know the area well, and the billing is clear and accurate.”'
    },
    {
        name: 'Ms. Namrata Vyas',
        designation: 'HR Executive, ThaneBiz Hub',
        rating: [1, 1, 1, 1, 1],
        text: '“Great service, clean cars, and always on time. Our team commutes stress-free every day, thanks to eTravo’s monthly rental plan.”'
    }
];




















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Cab Service in Thane",
  "image": "https://www.etravo.in/images/keyword/monthly-cab-service-thane.jpg",
  "description": "Hire monthly cab services in Thane for corporate employees, long-term rentals, and executive transport. Affordable and reliable monthly corporate cab hire with flexible plans and professional drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7825"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/monthly-cab-service-thane"
  }
};





    return (
        <div>
<Helmet>
  <title>Monthly Cab Service in Thane | Corporate & Executive Monthly Hire | eTravo</title>
  <meta 
    name="description" 
    content="Book monthly cabs in Thane for corporate employees, long-term leases, and executive travel. Reliable and affordable corporate cab rentals by eTravo with flexible monthly plans." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Monthlycabserviceinthane;